import { render } from "./GabungMitra.vue?vue&type=template&id=504d5f74&scoped=true"
import script from "./GabungMitra.vue?vue&type=script&lang=js"
export * from "./GabungMitra.vue?vue&type=script&lang=js"

import "./GabungMitra.vue?vue&type=style&index=0&id=504d5f74&scoped=true&lang=css"
import "./GabungMitra.vue?vue&type=style&index=1&id=504d5f74&lang=css"

import exportComponent from "/home/runner/work/yohom_cp/yohom_cp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504d5f74"]])

export default __exports__